$(function () {
  'use strict';

  var update = function () {
    vhCheck();
  }

  $(window).on('scroll', $.debounce(update));

  vhCheck();
});
